import { createSelector } from '@reduxjs/toolkit';
import { name } from './slice';
import type { IOrder } from './types';

export const getOrder = (state): IOrder => state.get(name);

export const getCancellationReasons = createSelector(
  getOrder,
  (order) => order.cancellationReasons,
);

export const getOrderInfo = createSelector(getOrder, (order) => order.info);

export const getCancellationRequestSent = createSelector(
  getOrder,
  (order) => order.info?.cancellation_request_sent,
);

export const getCancellationPolicy = createSelector(
  getOrder,
  (order) =>
    order.info?.cancellation_policy || order.info?.package?.cancellation_policy,
);

export const isConfirmedOrderSelector = createSelector(
  getOrder,
  (order) => order.info?.state === 'confirmed',
);

export const getCancellationReason = createSelector(
  getOrder,
  (order) => order.selectedCancelReason,
);

export const getCancellRequestStatus = createSelector(
  getOrder,
  (order) => order.cancellRequestStatus,
);

export const getChangesRequestStatus = createSelector(
  getOrder,
  (order) => order.changesRequestStatus,
);

export const getChangesTouristsRequestStatus = createSelector(
  getOrder,
  (order) => order.changesTouristsRequestStatus,
);

export const getPackageInfo = createSelector(
  getOrder,
  (order) => order.info?.package,
);

export const getPackageFlight = createSelector(
  getOrder,
  (order) => order?.info?.package?.flight_pair_id,
);

export const getPackageAdultsCount = createSelector(
  getOrder,
  (order) => order.info?.package?.adults_count,
);

export const getReasonText = createSelector(
  getOrder,
  (order) => order.customReasonText,
);

export const getRoomType = createSelector(
  getOrder,
  (order) => order?.info?.package?.room_type,
);

export const getMeal = createSelector(
  getOrder,
  (order) => order?.info?.package?.pansion_description,
);

export const getMealType = createSelector(
  getOrder,
  (order) => order?.info?.package?.pansion,
);

export const getStartDate = createSelector(
  getOrder,
  (order) => order?.info?.package?.start_date,
);

export const getNightsCount = createSelector(
  getOrder,
  (order) => order?.info?.package?.nights_count,
);

export const getHotelName = createSelector(
  getOrder,
  (order) => order?.info?.package?.hotel?.name,
);

export const getHotelStar = createSelector(
  getOrder,
  (order) => order?.info?.package?.hotel?.stars,
);

export const getHotelCountry = createSelector(
  getOrder,
  (order) => order?.info?.package?.hotel?.country,
);

export const getHotelRegion = createSelector(
  getOrder,
  (order) => order?.info?.package?.hotel?.city,
);

export const getHotelCountryIso2Order = createSelector(
  getOrder,
  (order) =>
    order?.info?.package?.country_to?.iso2 ||
    order?.info?.package?.hotel?.country_code,
);

export const getKidsAges = createSelector(
  getOrder,
  (order) => order?.info?.package?.kids_ages,
);

export const getExtras = createSelector(getOrder, (order) =>
  order?.info?.order_extras
    .filter((extra) => !extra.mandatory)
    .map((nameExtra) => ({ label: nameExtra.name, name: nameExtra.name })),
);

export const getChanges = createSelector(getOrder, (order) => order?.changes);

export const getTourists = createSelector(getOrder, (order) =>
  order?.info?.tourists.map((tourist) => ({
    id: tourist.id,
    surname: tourist.surname,
    name: tourist.name,
    gender: tourist.female ? 'F' : 'M',
    birthday: tourist.birthday,
    documentPrefix: tourist.passport_prefix,
    documentNumber: tourist.passport_number || tourist.passport, // passport_number - данные для десктопа, passport - данные для моб. версии
    documentExpirationDate: tourist.passport_expires_on,
  })),
);
